import { ContactPersonPipe } from './contact-person.pipe';
import { NgModule } from '@angular/core';
import { AddressPipe } from './address.pipe';

@NgModule({
    imports: [],
    exports: [AddressPipe, ContactPersonPipe],
    declarations: [AddressPipe, ContactPersonPipe],
    providers: [],
})
export class PatientPipesModule { }
